import React from "react";
import { Images } from "../config";

const SortButton = (props) => {
  return (
    <div
      {...props}
      className="h-[2.25em] w-[2.25em] cursor-pointer rounded-full bg-main flex justify-center items-center"
      title={props?.title ?? "Filter"}
    >
      <img src={Images.FilterIcon} className="w-7" />
    </div>
  );
};

export default SortButton;
